<template>
  <div class="favorite-page">
    <div class="list-block">
      <div class="top">
        <h3>我的收藏</h3>
      </div>
      <ul class="ls-items" v-if="sourceList.length > 0">
        <li class="acar" v-for="item in sourceList" :key="item.uuid">
            <div class="img" @click="navigateTo(`/h5/t12?id=${item.pageid}&psn=${item.psn}`)">
                <img v-if="item.imgs" :src="item | getFaceUrl" class="car-img"/>
            </div>
            <div class="des">
                <h3>{{item.title}}</h3>
                <div class="params">
                    <span>{{item | getYear}}年</span><span>{{item.trip | get10Thou}}万公里</span>
                </div>
                <div class="tags">
                    <span class="price">{{item.price / 100 | get10Thou}}万</span>
                </div>
            </div>
        </li>
      </ul>
      <div v-if="sourceList.length === 0 && dataLoaded">
        <div class="emp-box">
          <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/empty-content.png" class="emp-img"/>
          <span class="emp-txt">暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { getFavoriteList } from '../api'
import { Indicator } from 'mint-ui'
import { deepClone, navigateTo } from '../utils'
export default {
  components: {},
  props: {},
  data() {
    return {
      dataLoaded: false,
      sourceList: [],
      total: 0,
      queryParams: {
        page: 1,
        row: 20
      }
    };
  },
  watch: {
    userInfo(newInfo){
      this.getFavoriteDataList().then(res=>{
        
      })
    }
  },
  filters: {
      getFaceUrl(item){
          if(item.imgs){
              return item.imgs.split(',')[0] + '?x-oss-process=image/resize,l_150,m_lfit'
          }else{
              return undefined
          }
      },
      getYear(item){
          if(item.regDate){
              try{
                  return new Date(item.regDate.replace(/\-/g,"/")).getFullYear()
              }catch(ex){
                  return "0000"
              }
          }else{
              return "0000"
          }
      },
      get10Thou(price){
          if(price){
             return (price / 10000).toFixed(2) - 0
          }else{
              return ""
          }
      }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "userInfo"
    ])
  },
  methods: {
    navigateTo,
    async getFavoriteDataList(){
      let queryParams = deepClone(this.queryParams)
      const {user : {appid, openid}} = this.userInfo
      queryParams.qc_openid = openid
      Indicator.open('Loading...')
      const ret = await getFavoriteList(queryParams)
      this.dataLoaded = true
      Indicator.close()
      if(ret.code === 0 && ret.data){
        const { records, total} = ret.data
        const list = records.map(item => {
          const extinfo = JSON.parse(item.extinfo)
          return {
            title: item.title,
            imgs: item.imgs,
            price: extinfo.price,
            trip: extinfo.trip,
            power: extinfo.power,
            pageid: item.pageid,
            psn: extinfo.psn,
            uuid: item.uuid,
            regDate: extinfo.regDate
          }
        })
        this.sourceList = this.sourceList.concat(list)
      }
      console.log('......',ret)
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.favorite-page{
  margin: .2rem .3rem;
  .list-block{
    background:#fff;
    border-radius: 5px;
    .top{
      padding: .2rem .2rem;
      font-size: #333;
    }
    .ls-items{
    display: flex;
    flex-direction: column;
    .acar{
        display: flex;
        padding: .2rem 0rem;
        .img{
            margin-left: .2rem;
            width: 2.3rem;
            height: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background:#EDEDED url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/default-car-face.png') no-repeat center center;
            background-size: 60%;
            border-radius: 6px;
            .car-img{
                width: 2.3rem;
                height: 1.5rem;
                border-radius: 6px;
            }
        }
        .des{
            flex: 1;
            h3{
                padding: .1rem .2rem;
            }
            .params{
                padding: .1rem .2rem;
                font-size: .2rem;
                color: #888;
                span{
                    margin-right: .2rem;
                }
            }
            .tags{
                padding: .1rem .2rem;
                font-size: .2rem;
                span{
                    margin-right: .2rem;
                }
                .price{
                    color: #FF8E3B;
                }
                .tg1{
                    padding: .02rem .05rem;
                    background: #FAF3E4;
                    color: #EA9E33;
                }
                .tg2{
                    padding: .02rem .1rem;
                    background: #E4F5EE;
                    color: #55DE5F;
                }
            }
        }
    }
  }
  }
}
.emp-box{
  display:flex;
  flex-direction:column;
  align-items: center;
  .emp-img{
    max-width: 5.6rem;
  }
  .emp-txt{
    padding: .2rem;
    font-size: .3rem;
    color:#999;
  }
}
</style>